const styles = {
    statusText: {
        fontSize: "3vw",
    },
    statusImg : {
        height: "1.5vh",
        width: "1.5vh",
        marginLeft: "0.5vw"
    },
    flexContainer: {
        display: "flex",
        justifyContent:"left",
        paddingLeft: "0",
        paddingTop:"0",
        marginTop: "0.5vh",
        alignItems:'center'
    },
    dateText: {
        marginRight: "4vw",
        color: "rgb(45,45,45)",
    },
    center: {
        justifyContent: "center"
    }
}

export default styles;
